import axios from 'axios';
import JustValidate from 'just-validate';

import utils from '../functions-base/utils';
import changePassword from './change-password';

declare let core_object: any;
declare let auth_object: any;

// Utils
const modUtils = new utils();

export default class validateCode{

    protected elWrapForm: string;
    protected elForm: string;
    protected elFormAlert: string;
    protected elFormBtn: string;
    protected elFormSpin: string = 'bgdrop-spin';
    protected url_api_validate_code: string;
    protected modChangePassword: changePassword;

    /**
     * Constructor
     * @param elWrapForm
     * @param elForm 
     * @param elFormAlert 
     * @param elFormBtn 
     */
    constructor(
        elWrapForm: string,
        elForm: string,
        elFormAlert: string,
        elFormBtn: string,
    ) {

        this.elWrapForm = elWrapForm;
        this.elForm = elForm;
        this.elFormAlert = elFormAlert;
        this.elFormBtn = elFormBtn;
        this.url_api_validate_code = auth_object.rest_urls.auth_validate_code;

        // Change password
        this.modChangePassword = new changePassword(
            this.elWrapForm,
            this.elForm,
            this.elFormAlert,
            this.elFormBtn,
        );

    }

    /**
     * Validate code
     * @returns 
     */
    validate(){
        
        const _that = this;

        const validation = new JustValidate(this.elForm, {
            errorFieldCssClass: 'is-invalid border border-red-300',
            errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1 !text-red-300',
            focusInvalidField: true,
            lockForm: true,
        });

        validation.addField('#auth_code_forgot_password', [
            {
                rule: 'required',
                errorMessage: auth_object.error_messages.field_required,
            },
        ])
        .onSuccess((event: any) => {
                
                event.preventDefault();
            
                _that.sendApi(event?.currentTarget);
                
        });

        return validation;

    }

    /**
     * Send code
     * @param form 
     */
    protected sendApi(form: HTMLFormElement) {
        
        const _that = this;

        // Wrap form
        const wrap_form = document.querySelector(_that.elWrapForm) as HTMLElement | null;

        // Get form data
        const data = new FormData(form); 
        
        // Conver form data to string
        const datastring = new URLSearchParams(data as any).toString();

        // Button
        const btn = document.querySelector(this.elFormBtn) as HTMLButtonElement | null;

        // Init post data
        const post_data = {
            ajax_nonce: core_object.ajaxNonce,
            'fields': datastring
        };

        // Create query string
        const queryString = new URLSearchParams(post_data).toString();

        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Init spin
        const spin = modUtils.btnSpin(this.elFormSpin);

        // Append spin to button
        btn?.append(spin);

        // Call ajax
        axios.post(_that.url_api_validate_code, queryString)
            .then(function (response: any) {
                
            // Remove alert box
            modUtils.removeAlertBox(
                _that.elForm,
                _that.elFormAlert
            );

            // Remove spin
            spin.remove();
                
            // Remove disabled attribute
            btn?.removeAttribute('disabled');

            const responseStatus: boolean = response.data.status;
                
            // True
            if(responseStatus == true){
                
                form.remove();
                
                const getTemplate = response.data.template as string;

                // Append Template
                wrap_form?.insertAdjacentHTML('afterbegin', getTemplate);

                // Validate form
                const validation = _that.modChangePassword.validate();

            }

            // False
            if(responseStatus == false){
                
                // Get errors
                const errors = response.data.errors;
                
                if(Array.isArray(errors)){
                    
                    errors.forEach(function(error){
                        
                        let alert = modUtils.alertBox(
                            _that.elFormAlert,
                            auth_object.general_message.error,
                            error
                        );
                        form.prepend(alert);

                    });

                }else{
                    
                    const alert = modUtils.alertBox(
                        _that.elFormAlert,
                        auth_object.general_message.error,
                        errors
                    );
                    form.prepend(alert);

                }
  
            }

        })
        .catch(function (error:any){

            // Remove spin
            spin.remove();

            // Remove disabled attribute
            btn?.removeAttribute('disabled');

        });

    }

}